import { Component, OnInit } from '@angular/core';
import { FinanceService } from 'src/modules/features/contractor/services';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
import { ConfirmModal, EmailModal } from 'src/modules/shared';
import { FormControl, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { DecimalPipe } from '@angular/common';

@Component({
  selector: 'app-agent-lot-details',
  templateUrl: './lot-detail.component.html',
  styleUrls: ['./lot-detail.component.scss'],
})
export class LotAgentDetailsComponent implements OnInit {
  success: any;
  error: any;
  pending: boolean;
  formStructure: any;
  currency: Array<any> = [];
  paymentInstructions: any;
  payment: any;
  requireInvoiceNo: boolean;
  invoiceDetail: any;
  paymentDetail: any;

  invoiceNo = new FormControl('', Validators.required);
  invoiceNumber;
  amount;
  revenueServiceId;
  allowPartPayment;
  companyName: string;
  purpose: string;
  currencyId = 'naira';
  requireInvoice: boolean = false;
  paymentType: string = 'LOCAL';
  errorayment;
  description = '';
  payersAddress = '';
  payersEmail = '';
  payersPhone = '';
  payersName = '';
  email;
  confirmEmail;
  organization;
  formFields = [];
  constructor(
    private modalService: SuiModalService,
    private location: Location,
    private activatedRoute: ActivatedRoute,
    private financeSvc: FinanceService,
    private router: Router,
    private decimalPipe: DecimalPipe
  ) {
    this.pending = true;
    this.payment = financeSvc.payment;
    this.organization = JSON.parse(window.localStorage.getItem('organization'));
    let user = JSON.parse(window.localStorage.getItem('user'));
    this.payersAddress =
      this.organization.jpaContractor.headOfficeAddressStreet;
    this.payersPhone = this.organization.jpaContractor.companyContactPhone1;
    this.payersName =
      this.organization.organizationShortName ||
      this.organization.organizationLongName;
    this.email = user.appUserEmail;
    this.payersEmail = user.appUserEmail;
    this.confirmEmail = this.email;
    // if (this.financeSvc.payment) {
    // } else {
    // 	this.location.back();
    // }
    this.activatedRoute.queryParams.subscribe((querys) => {
      this.purpose = querys['purpose'];
      this.invoiceNumber = querys['invoiceNumber'];
      this.revenueServiceId = querys['revenueServiceId'];
      this.requireInvoiceNo = querys['requireInvoiceNo']
        ? JSON.parse(querys['requireInvoiceNo'])
        : false;
      this.requireInvoice = querys['requireInvoiceNo']
        ? JSON.parse(querys['requireInvoiceNo'])
        : false;
      this.amount = this.decimalPipe.transform(querys['amount'], '.2-2');
      this.allowPartPayment = querys['allowPartPayment']
        ? JSON.parse(querys['allowPartPayment'])
        : false;

      this.getCurrenccy(this.revenueServiceId);
      this.getControlItem(this.revenueServiceId);

      if (this.invoiceNumber) {
        this.getInvoice(this.invoiceNumber);
        this.getControlItem(this.revenueServiceId);
      }
    });
  }
  getCurr() {
    let cu = this.currency.filter((curr) => curr.currencyId == this.currencyId);
    return cu[0] ? cu[0]['currencyShortName'] : '';
  }
  getControlItem(revenueServiceId) {
    this.pending = true;
    this.financeSvc
      .getConsoleItem({ revenueServiceId: revenueServiceId })
      .subscribe(
        (res: any) => {
          this.pending = false;
          this.formStructure = res.itemConfig ? JSON.parse(res.itemConfig) : [];
          this.formFields = this.formStructure
            .map((struct) => struct.structure)
            .flat()
            .map((fields) => fields.name);
          // console.log();
        },
        (error) => {
          this.pending = false;
          this.error = error.error
            ? error.error['status'] == 404
              ? "You can't pay for this service"
              : error
            : error;
        }
      );
  }
  getField(name) {
    return this.formFields.indexOf(name) > -1;
  }
  nullify() {
    this.error = null;
  }
  getCurrenccy(revenueServiceId) {
    this.pending = true;
    this.financeSvc
      .getCurrency({ revenueServiceId: revenueServiceId })
      .subscribe(
        (res: any) => {
          this.pending = false;
          this.currency = res;
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error
            ? error.error
            : error;
        }
      );
  }

  submitInvoice() {
    if (this.invoiceNo.valid) {
      this.getInvoice(this.invoiceNo.value.replace(/\s/g, ''));
    } else {
      this.error = 'Please enter a valid invoice number';
    }
  }

  getInvoice(number) {
    this.pending = true;
    this.financeSvc
      .getInvoiceDetail({ params: { invoiceNumber: number } })
      .subscribe(
        (res) => {
          this.pending = false;
          if (res['revenueServiceId'] == this.revenueServiceId) {
            this.invoiceDetail = res;
            this.invoiceNumber = number;
            this.description = res['description'];
            // tamsy invoice check categoryName

            if (res['categoryName'] === 'Type Approval') {
              this.checkSimilarEquipment(number, res);
            } else {
              if (res['status'] != 'PAID') {
                this.getPayment(res);
              } else {
                this.error = `This invoice has already been ${res['status']} `;
              }
            }
          } else {
            this.error =
              "Revenue service selected doesn't match invoice revenue service";
          }
        },
        (error) => {
          this.pending = false;
          this.error = 'Invoice not found';
        }
      );
  }

  checkSimilarEquipment(number, response) {
    this.pending = true;
    this.financeSvc.checkSimilarEquipment({ invoiceNumber: number }).subscribe(
      (res) => {
        this.pending = false;
        console.log(res, 'similar check');
        if (res.status == true) {
          this.error = `This invoice has a similar equipment that has already been Paid for `;
          console.log('I don pay', response);
          // this.cancelTamsyInvoice(response.invoiceId);
        } else {
          this.getPayment(response);
        }
      },
      (error) => {
        this.pending = true;
        this.error = error.error.errorMessage
          ? error.error.errorMessage
          : error.error
          ? error.error
          : error;
      }
    );
  }
  cancelTamsyInvoice(item) {
    this.pending = true;
    this.financeSvc.cancelTamsyInvoice({ invoiceId: item }).subscribe(
      (res) => {
        this.pending = false;
        console.log(res, 'cancelled');
      },
      (error) => {
        this.pending = true;
        this.error = error.error.errorMessage
          ? error.error.errorMessage
          : error.error
          ? error.error
          : error;
      }
    );
  }

  goToPayment() {
    if (this.paymentDetail['paymentDetails']['invoice_number']) {
      this.router.navigate(['/contractor/payment/instruction'], {
        queryParams: {
          invoiceNumber: this.paymentDetail['paymentDetails']['invoice_number'],
          transactionRef: this.paymentDetail['transactionRef'],
        },
      });
    } else {
      this.router.navigate(['/contractor/payment/instruction'], {
        queryParams: {
          purpose: this.purpose,
          beneficiary: 'Nigerian Communications Commision',
          amount: this.invoiceDetail['amount'],
          rrr: this.paymentDetail['transactionRef'],
          paymentLink: this.paymentDetail['paymentUrl'],
          address: this.paymentDetail['paymentDetails']['payers_address'],
          companyName: this.invoiceDetail['companyName'],
          currencyCode: this.invoiceDetail['currencyCode'],
          docPath: this.paymentDetail['detailsDocumentPath'],
          description:
            this.paymentDetail['paymentDetails']['description'] === null
              ? this.paymentDetail['paymentDetails']['invoice_description']
              : this.paymentDetail['paymentDetails']['description'],
          name: this.paymentDetail['paymentDetails']['payers_name'],
          initiatedPaymentId: this.paymentDetail['initiatedPaymentId'],
          phone: this.paymentDetail['paymentDetails']['payers_phone'],
          email: this.paymentDetail['paymentDetails']['payers_email'],
          paymentType:
            this.paymentDetail['currencyId'] == 'naira' ? 'LOCAL' : 'FOREIGN',
          invoiceNo: this.paymentDetail['paymentDetails']['invoice_number'],
          internalTransactionRef: this.paymentDetail['internalTransactionRef'],
        },
      });
    }
  }

  getPayment(invoice) {
    this.financeSvc
      .getInvoicePayment({ params: { invoiceNumber: invoice.invoiceNumber } })
      .subscribe(
        (res) => {
          this.pending = false;
          this.paymentDetail = res;
          this.errorayment = true;
          setTimeout(() => {
            this.errorayment = false;
          }, 5000);
        },
        (error) => {
          this.pending = false;
          this.invoiceDetail = invoice;
          this.paymentType =
            invoice['currencyId'] == 'naira' ? 'LOCAL' : 'FOREIGN';
          this.currencyId = invoice['currencyId'];
          this.requireInvoiceNo = false;
          this.companyName = this.invoiceDetail.companyName;
          this.amount = this.decimalPipe.transform(invoice['amount'], '.2-2');
        }
      );
  }

  submit(value, validation) {
    if (validation == true) {
      if (
        value['payers_email'] == undefined ||
        value['payers_email'] == '' ||
        value['payers_email'] != value['confirm_email']
      ) {
        this.error = 'Provided email does not match';
        return;
      }
      this.pending = true;
      if (this.invoiceNumber) {
        value['invoice_number'] = this.invoiceNumber;
      }
      value['amount_to_pay'] = <any>value['amount_to_pay'].replace(/,/g, '');
      value['revenue_service_id'] = this.revenueServiceId;
      value['ncc_id'] = this.organization['jpaContractor']['nccId'];
      this.financeSvc.makePayment({ body: value }).subscribe(
        (res: any) => {
          this.pending = false;
          this.financeSvc.payment = {
            paymentInstructions: res.paymentInstructions,
            value: value,
          };
          if (value['invoice_number']) {
            this.router.navigate(['/contractor/payment/instruction'], {
              queryParams: {
                invoiceNumber: value['invoice_number'],
                transactionRef: res['transactionRef'],
              },
            });
          } else {
            this.router.navigate(['/contractor/payment/instruction'], {
              queryParams: {
                purpose: this.purpose,
                amount: value['amount_to_pay'],
                beneficiary: 'Nigerian Communications Commision',
                rrr: res['transactionRef'],
                transactionRef: res['transactionRef'],
                description: value['invoice_description']
                  ? value['invoice_description']
                  : value['description'],
                address: value['payers_address'],
                name: value['payers_name'],
                phone: value['payers_phone'],
                email: value['payers_email'],
                paymentLink: res['paymentUrl'],
                docPath: res['detailsDocumentPath'],
                currencyCode: this.currency.filter(
                  (curr) => curr.currencyId == value['currency_id']
                )[0].currencyCode,
                paymentType: value['payment_type'],
                initiatedPaymentId: res['initiatedPaymentId'],
                internalTransactionRef: res['internalTransactionRef'],
              },
            });
          }
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error
            ? error.error
            : error;
        }
      );
    } else {
      this.error = 'Please provide value for the required fields';
    }
  }

  goBack() {
    this.location.back();
  }

  ngOnInit(): void {}
}
